import React from 'react'

//Helpers
import { getCountUnities, getMinAndMaxPrice } from '@helpers/helper.unities'
import { getLocation, getStatus, getContructionDate, getType } from '@helpers/helper.developments'

import useQueryUnities from '@hooks/useQueryUnities'
import useQueryDevelopment from '@hooks/useQueryDevelopment'
import { RealEstateDataPageComponentData } from 'types'

interface ExternalProps {
  developmentID: string
}

type CombinedProps = RealEstateDataPageComponentData & ExternalProps

const AboutDevelopment_1 = ({
  developmentID,
  darkMode,
  amenitiesBarDev,
  global_data,
  hidden,
}: CombinedProps) => {
  const icons = global_data.pageConfig.design.icons
  const iconsStyle = icons === 'Solid' || icons === 'Light' ? `-${icons.toLowerCase()}` : ''

  const API_KEY = global_data.pageConfig.keys.tokko

  const { data: allDevelopmentData } = useQueryDevelopment(developmentID, API_KEY)
  const {
    allUnitiesData,
    isLoading: isLoadingUnities,
    isError: isErrorUnities,
  } = useQueryUnities(developmentID, API_KEY)

  return (
    <section
      className={`about-top a amenities ${!darkMode && 'dark-mode'} ${
        hidden ? 'py-1 py-lg-4' : ''
      }`}
    >
      <div className="container-fluid px-lg-5">
        <div
          className={`d-flex flex-wrap align-items-lg-start justify-content-lg-${
            hidden ? 'center' : 'around'
          } justify-content-center text-center`}
        >
          {!hidden && (
            <div className="column 6 col-12 d-lg-none d-block order-1 order-lg-6">
              <div className="row with-border py-2">
                <div className="order-lg-1 col-12 pe-lg-5 py-4 py-lg-0 d-flex align-items-start justify-content-lg-evenly justify-content-around flex-lg-column">
                  {/* {!isLoadingUnities || !isErrorUnities ? (
                  ''
                ) :  */}
                  <>
                    <div className="item mb-lg-4 d-lg-block">
                      <p className="mb-lg-0 me-lg-4 text-center">Desde</p>
                      <h4>
                        {isLoadingUnities || isErrorUnities
                          ? 'Cargando..'
                          : 'USD ' +
                            Intl.NumberFormat('de-DE').format(
                              getMinAndMaxPrice(allUnitiesData).min,
                            )}
                      </h4>
                    </div>
                    <div className="item d-lg-block">
                      <p className="me-lg-4 mb-lg-0 text-center">Hasta</p>
                      <h4>
                        {isLoadingUnities || isErrorUnities
                          ? 'Cargando..'
                          : 'USD ' +
                            Intl.NumberFormat('de-DE').format(
                              getMinAndMaxPrice(allUnitiesData).max,
                            )}
                      </h4>
                    </div>
                  </>
                  {/* } */}
                </div>
              </div>
            </div>
          )}
          {amenitiesBarDev?.type && (
            <div
              className={`column pb-4 py-4 py-lg-4 col-6 col-lg-${
                hidden ? '2' : 'auto'
              } d-none d-lg-block 2 order-lg-2 order-2 ${hidden ? 'mx-3' : ''}`}
            >
              <i className={`icon-building${iconsStyle} me-lg-0 text-center text-lg-start`}></i>
              <div className="info text-center text-lg-start">
                <h3 className="mb-2 mb-lg-1">{amenitiesBarDev?.type}</h3>
                <p>{getType(allDevelopmentData)}</p>
              </div>
            </div>
          )}
          {amenitiesBarDev?.state && (
            <div
              className={`column pb-4 py-4 py-lg-4 col-6 col-lg-${
                hidden ? '2' : 'auto'
              } d-block 2 order-lg-2 order-2 ${hidden ? 'mx-3' : ''}`}
            >
              <i
                className={`icon-construction_state${iconsStyle} me-lg-0 text-center text-lg-start`}
              ></i>
              <div className="info text-center text-lg-start">
                <h3 className="mb-2 mb-lg-1">{amenitiesBarDev?.state}</h3>
                <p>{getStatus(allDevelopmentData)}</p>
              </div>
            </div>
          )}
          {amenitiesBarDev?.unities && (
            <div
              className={`column py-4 py-lg-4 col-6 col-lg-${
                hidden ? '2' : 'auto'
              } d-block 1 order-lg-3 order-3 ${hidden ? 'mx-3' : ''}`}
            >
              <i className={`icon-unit${iconsStyle} me-lg-0 text-center text-lg-start`}></i>
              <div className="info text-center text-lg-start">
                <h3 className="mb-2 mb-lg-1">{amenitiesBarDev?.unities}</h3>
                <p>
                  {isLoadingUnities || isErrorUnities
                    ? ''
                    : getCountUnities(allUnitiesData, !API_KEY) || 'Sin especificar'}
                </p>
              </div>
            </div>
          )}
          {!API_KEY && allDevelopmentData?.parking_lot?.length > 0 && (
            <div className="column py-4 py-lg-4 col-6 col-lg-auto d-block 3 order-lg-4 order-4">
              <i className={`icon-parking${iconsStyle} me-lg-0 text-center text-lg-start`}></i>
              <div className="info text-center text-lg-start">
                <h3 className="mb-2 mb-lg-1">COCHERAS</h3>
                {!isLoadingUnities
                  ? (allDevelopmentData?.parking_lot).map((park: any) => (
                      <p>
                        {park.parking_lot_amount}{' '}
                        {(park.parking_lot_type !== '' &&
                        park.parking_lot_type.toLowerCase() !== 'sin especificar'
                          ? ' ' +
                            park.parking_lot_type
                              ?.split(' ')
                              ?.map(
                                (text: string) =>
                                  text.toLowerCase() + (park.parking_lot_amount > 1 ? 's' : ''),
                              )
                          : ''
                        ).replaceAll(',', ' ')}
                      </p>
                    ))
                  : ''}
              </div>
            </div>
          )}
          {amenitiesBarDev?.location && (
            <div
              className={`column py-4 py-lg-4 col-6 col-lg-${
                hidden ? '2' : 'auto'
              } d-block 3 order-lg-4 order-4 ${hidden ? 'mx-3' : ''}`}
            >
              <i className={`icon-location${iconsStyle} me-lg-0 text-center text-lg-start`}></i>
              <div className="info text-center text-lg-start">
                <h3 className="mb-2 mb-lg-1">{amenitiesBarDev?.location}</h3>
                <p>
                  {getLocation(allDevelopmentData, true)[0]} <br />{' '}
                  {getLocation(allDevelopmentData, true)[1]}
                </p>
              </div>
            </div>
          )}
          {amenitiesBarDev?.delivery && (
            <div
              className={`column py-4 py-lg-4 col-6 col-lg-${
                hidden ? '2' : 'auto'
              } d-block 4 order-lg-5 order-5 ${hidden ? 'mx-3' : ''}`}
            >
              <i
                className={`icon-delivery-date${iconsStyle} me-lg-0 text-center text-lg-start`}
              ></i>
              <div className="info text-center text-lg-start">
                <h3 className="mb-2 mb-lg-1">{amenitiesBarDev?.delivery}</h3>
                <p>
                  {getStatus(allDevelopmentData)?.toString().toLowerCase().includes('termin')
                    ? '-'
                    : getContructionDate(allDevelopmentData) || 'Sin especificar'}
                </p>
              </div>
            </div>
          )}
          {!hidden && (
            <div className="column col-lg-3 col-12 6 d-lg-block d-none order-1 order-lg-6">
              <div className="row with-border py-2">
                <div className="col-12 pe-lg-5 py-4 py-lg-0 d-flex align-items-start justify-content-end flex-column">
                  <>
                    <div className="item mb-lg-2 d-flex d-lg-block">
                      <p className="mb-4 mb-lg-0 mr-4">Desde</p>
                      <h4>
                        {isLoadingUnities || isErrorUnities
                          ? 'Cargando..'
                          : 'USD ' +
                            Intl.NumberFormat('de-DE').format(
                              getMinAndMaxPrice(allUnitiesData).min,
                            )}
                      </h4>
                    </div>
                    <div className="item d-flex d-lg-block">
                      <p className="mr-4 mb-lg-0">Hasta</p>
                      <h4>
                        {isLoadingUnities || isErrorUnities
                          ? 'Cargando..'
                          : 'USD ' +
                            Intl.NumberFormat('de-DE').format(
                              getMinAndMaxPrice(allUnitiesData).max,
                            )}
                      </h4>
                    </div>
                  </>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </section>
  )
}

export default AboutDevelopment_1
